class FooterParallax extends HTMLElement {
  connectedCallback() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.waitForSectionInView();
      }, 1000);
    });
  }

  waitForSectionInView() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.disconnect();
          this.initAnimation();
        }
      });
    }, {
      rootMargin: '500px 0px 0px 0px'
    });

    observer.observe(this);
  }

  initAnimation() {
    if (!window.gsap || !window.ScrollTrigger) return;
    
    const overlay = this.querySelector(".footer-container-overlay");
    if (!overlay) return;

    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      overlay,
      { y: window.innerHeight * 0.6, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: this,
          start: "top bottom-=25%",
          end: "bottom bottom",
          scrub: 0.5,
          markers: false,
        },
      }
    );
  }
}

customElements.define("footer-parallax", FooterParallax)



class ScrollStepsAnimation extends HTMLElement {
  connectedCallback() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.waitForSectionInView();
      }, 1000);
    });
  }

  waitForSectionInView() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.disconnect();
          this.initAnimation();
        }
      });
    }, {
      rootMargin: '500px 0px 0px 0px'
    });

    observer.observe(this);
  }

  initAnimation() {
    if (!window.gsap || !window.ScrollTrigger) return;
    
    const verticalLine = this.querySelector('.vertical-line-progress');
    const steps = this.querySelectorAll('.step-item');
    
    if (!verticalLine || steps.length === 0) return;

    gsap.registerPlugin(ScrollTrigger);
    
    gsap.set(verticalLine, { height: 0 });
    gsap.set(steps, { opacity: 0, y: 24 });
    
    gsap.fromTo(verticalLine, 
      { height: "0%" }, 
      { 
        height: "100%",
        ease: "none",
        scrollTrigger: {
          trigger: this,
          start: "top 40%",
          end: "bottom bottom-=10%",
          scrub: true
        }
      }
    );
    
    steps.forEach((step, index) => {
        gsap.to(step, {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: step,
              start: "top 60%",
              end: "bottom 40%",
              toggleActions: "play none none reverse"
            }
        });
    });
  }
}

customElements.define("scroll-steps-animation", ScrollStepsAnimation);